"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilePickerAction;
(function (FilePickerAction) {
    FilePickerAction[FilePickerAction["Attach"] = 0] = "Attach";
    FilePickerAction[FilePickerAction["Share"] = 1] = "Share";
    FilePickerAction[FilePickerAction["Insert"] = 2] = "Insert";
    FilePickerAction[FilePickerAction["AttachAndShare"] = 3] = "AttachAndShare";
})(FilePickerAction || (FilePickerAction = {}));
exports.default = FilePickerAction;
//# sourceMappingURL=FilePickerAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/store/schema/FilePickerAction.js
// module id = 1778
// module chunks = 2 3 43 106 107